// extracted by mini-css-extract-plugin
export default {"logo":"AppBar_logo__jiyWT","title":"AppBar_title__bPDfu"};